import { z } from 'zod';

export const schemaStartInteractionResponse = z.object({});
export type SchemaStartInteractionResponse = z.infer<typeof schemaStartInteractionResponse>;
